import { render, staticRenderFns } from "./BusinessNameAmendmentApplications.vue?vue&type=template&id=c92f884e&scoped=true&"
import script from "./BusinessNameAmendmentApplications.vue?vue&type=script&lang=js&"
export * from "./BusinessNameAmendmentApplications.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameAmendmentApplications.vue?vue&type=style&index=0&id=c92f884e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92f884e",
  null
  
)

export default component.exports